<template>
  <form
    :action="route('admin.work-order.index')"
    method="GET"
    class="flex items-center flex-wrap -mx-2"
  >
    <div class="w-1/4 px-2">
      <v-select
        v-model="selectedStatus"
        :multiple="true"
        :options="statuses"
        name="status"
        :reduce="(item) => item.value"
      >
      </v-select>

      <input
        v-for="item in selectedStatus"
        type="hidden"
        name="status[]"
        :key="item"
        :value="item"
      />
    </div>

    <button type="submit" class="btn btn-sm">Filter</button>
  </form>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },

  props: {
    statuses: {
      required: true,
      type: Array,
    },
    currentStatus: {
      required: false,
      default: [],
    }
  },

  data() {
    return {
      selectedStatus: [],
    };
  },

  created() {
    if (this.currentStatus.length > 0) {
      this.selectedStatus = this.currentStatus;
    }
  },
};
</script>
